// =============================================================================
// MetaTags — 페이지별 SEO 메타 정보
// (2026-05-06) 리뉴얼 후 핵심 3개 페이지 (membership / retail-pos / food-pos)
// 만 페이지별 메타 적용. 나머지 (crm, cases, extra-service, pricing) 는
// public/index.html 의 default landing 메타 사용.
//
// 기존 레거시 페이지 (mini, getStarted, featureKds, featureKiosk 등) 의
// 엔트리는 모두 제거 — 라우트 자체가 삭제됐고 imageSrc 의 src/img 경로도
// 정리되면서 깨진 링크였음.
// =============================================================================

const SITE_URL = "https://thegrowing.co";

export default {
  // Default — 랜딩 페이지. App.js getPage 의 fallback case 와도 매핑.
  // public/index.html 의 default 와 의미 동일.
  landing: {
    title: "그로잉세일즈 — 온·오프라인 멤버십 통합 솔루션",
    description:
      "매장과 자사몰의 포인트·쿠폰을 하나로. POS, CRM, 멤버십 통합을 한 번에. 그로잉세일즈로 매장 운영을 시작하세요.",
    keywords:
      "멤버십 통합, 자사몰 연동, POS, 카페24 연동, 온오프라인 통합, 키오스크, 테이블오더, KDS, CRM, 웨이팅",
    imageSrc: `${SITE_URL}/img/landing/og-default.png`,
    url: `${SITE_URL}/`,
  },

  // 멤버십 통합 (/products/membership)
  membership: {
    title: "온·오프라인 멤버십 통합 — 그로잉세일즈",
    description:
      "매장과 자사몰의 적립금·쿠폰·등급을 하나로 연결합니다. 카페24 자사몰 연동부터 등급 자동 산정·CRM 캠페인까지 — 멤버십을 통합으로 매출이 성장합니다.",
    keywords:
      "멤버십 통합, 카페24 연동, 자사몰 연동, 온오프라인 멤버십, 등급 산정, 적립금 통합, 쿠폰 통합, CRM",
    imageSrc: `${SITE_URL}/img/membership/hero.png`,
    url: `${SITE_URL}/products/membership`,
  },

  // 리테일 POS (/products/retail-pos)
  retailPos: {
    title: "리테일 POS — 그로잉세일즈",
    description:
      "스캔하는 순간 매장과 자사몰 재고가 동시에 움직입니다. 카운터, 재고관리, 스마트폰 재고조회까지. 패션·뷰티·잡화 등 소매업에 최적화된 리테일 POS.",
    keywords:
      "리테일 POS, 의류 포스, 패션 포스, 재고관리, 자사몰 재고 동기화, 바코드 스캔, 매장 운영, 소매업 포스",
    imageSrc: `${SITE_URL}/img/retailPos/hero-bg.png`,
    url: `${SITE_URL}/products/retail-pos`,
  },

  // 도입사례 목록 (/cases)
  // 상세(/cases/:slug)는 Notion 에서 동기화된 케이스 JSON 의 `seo` 필드를
  // CaseDetail.js 가 직접 사용한다 — scripts/lib/case-seo.js 참고.
  cases: {
    title: "도입사례 | 그로잉세일즈",
    description:
      "카페24 자사몰과 오프라인 매장의 멤버십을 하나로 통합한 리테일·외식 브랜드들의 실제 운영 사례. 포인트 적립, 지점관리, 테이블오더까지 도입 전후를 확인하세요.",
    keywords:
      "그로잉세일즈 도입사례, 멤버십 통합 사례, 카페24 연동 사례, 포인트 적립, 매장 POS 도입, 리테일 도입사례, 외식 도입사례",
    imageSrc: `${SITE_URL}/img/landing/og-default.png`,
    url: `${SITE_URL}/cases`,
  },

  // 활용백서 목록 (/playbook)
  // 우진 (2026-09-09): 상세(/playbook/:slug)는 playbook-content JSON 의
  // `seo` 필드를 PlaybookDetail.js 가 직접 사용한다.
  playbook: {
    title: "활용백서 | 그로잉세일즈",
    description:
      "그로잉세일즈를 제대로 쓰는 법. 온·오프라인 멤버십 통합, 자사몰 상품 동기화, 매장 할인, 고객 태그와 타겟 메시지, 자동 캠페인, 리포트까지 — 실제 운영 화면으로 설명하는 활용 가이드.",
    keywords:
      "그로잉세일즈 활용백서, 그로잉세일즈 사용법, 멤버십 통합, 상품 동기화, 매장 할인 설정, 고객 태그, 타겟 메시지, 자동 캠페인, 캠페인 리포트, 카페24 연동",
    imageSrc: `${SITE_URL}/img/landing/og-default.png`,
    url: `${SITE_URL}/playbook`,
  },

  // 외식 POS (/products/food-pos)
  foodPos: {
    title: "외식 POS — 그로잉세일즈",
    description:
      "매장 주문, 키오스크, 테이블오더, 배달까지 모든 주문이 모입니다. 메뉴·할인 운영, 하드웨어 연동, KDS·웨이팅 통합. 카페·음식점에 최적화된 외식 POS.",
    keywords:
      "외식 POS, 카페 포스, 음식점 포스, 테이블오더, 키오스크, KDS, 배달앱 연동, 메뉴 운영, 외식업 포스",
    imageSrc: `${SITE_URL}/img/foodPos/hero.png`,
    url: `${SITE_URL}/products/food-pos`,
  },
};
